import { z } from 'zod';
import { BaseResponseSchema, } from './primitives.js';
// ========================================
// Provider Ops — Gateway Health Dashboard
// ========================================
export const GatewayHeartbeatStatusSchema = z.enum(['active', 'stale', 'unknown']);
export const GatewayOverallHealthSchema = z.enum(['healthy', 'degraded', 'unhealthy', 'unknown']);
export const GatewayHealthRowSchema = z.object({
    // Canonical Cnapse Serial Number
    serialNumber: z.string(),
    tenantId: z.string().nullable().optional(),
    siteId: z.string().nullable().optional(),
    deviceCategory: z.string().nullable().optional(),
    inventoryStatus: z.string().nullable().optional(),
    iotProvisioningStatus: z.string().nullable().optional(),
    gatewayHeartbeatLastSeenAt: z.string().nullable().optional(),
    gatewayHeartbeatStatus: GatewayHeartbeatStatusSchema,
    guardHeartbeatLastSeenAt: z.string().nullable().optional(),
    guardHeartbeatStatus: GatewayHeartbeatStatusSchema,
    overallHealth: GatewayOverallHealthSchema,
    // Orchestrator self-reported status from the heartbeat payload
    orchestratorStatus: z.enum(['active', 'degraded', 'impaired']).nullable().optional(),
    // Human-readable detail explaining a degraded/impaired status
    statusDetails: z.string().nullable().optional(),
    reprovisioningPermitted: z.boolean().optional(),
});
export const GatewayHealthSummarySchema = z.object({
    total: z.number().int().min(0),
    healthy: z.number().int().min(0),
    degraded: z.number().int().min(0),
    unhealthy: z.number().int().min(0),
    unknown: z.number().int().min(0),
});
export const GatewayHealthListQuerySchema = z.object({
    tenantId: z.string().optional(),
    siteId: z.string().optional(),
    deviceCategory: z.string().optional(),
    overallHealth: GatewayOverallHealthSchema.optional(),
    search: z.string().max(100).optional(),
    cursor: z.string().optional(),
    limit: z.coerce.number().int().min(1).max(200).default(50),
});
export const GatewayHealthListResponseSchema = BaseResponseSchema.extend({
    data: z.object({
        gateways: z.array(GatewayHealthRowSchema),
        summary: GatewayHealthSummarySchema,
        nextCursor: z.string().nullable().optional(),
        count: z.number().int().min(0),
    }),
});
//# sourceMappingURL=ops-gateway-health.schemas.js.map